import { render } from "./Percent5.vue?vue&type=template&id=ba8a57c6"
import script from "./Percent5.vue?vue&type=script&lang=js"
export * from "./Percent5.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__